import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
import type { GuaranteeContent } from '../../types/salesPage';
interface GuaranteeBlockProps {
  content: GuaranteeContent;
}
export function GuaranteeBlock({
  content
}: GuaranteeBlockProps) {
  return <section aria-labelledby="guarantee-title" className="border-t border-white/[0.07] bg-carbon px-5 py-14 sm:px-6 md:py-20" data-id="element-117" data-mp="39wqzktz2a009">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-70px'
    }} transition={{
      duration: 0.55,
      ease: 'easeOut'
    }} className="mx-auto flex max-w-3xl flex-col items-center gap-6 rounded-sm border border-gold/25 bg-panel px-5 py-8 text-center sm:px-9 sm:py-9 md:flex-row md:gap-9 md:text-left" data-id="element-118" data-mp="3os6ybcal6k2z">
        <div className="relative flex h-24 w-24 shrink-0 items-center justify-center rounded-full border border-gold/45 bg-gold/[0.07] sm:h-28 sm:w-28" data-id="element-119" data-mp="bfd9efvxntrn">
          <ShieldCheck aria-hidden="true" className="absolute h-10 w-10 text-gold/25" data-id="element-120" data-mp="39v5tf9kpq9x" />
          <div className="relative text-center" data-id="element-121" data-mp="886f9ovyhyrm">
            <p className="font-serif text-[24px] font-bold leading-none text-gold-soft" data-id="element-122" data-mp="88ybn1xdo0iy">
              {content.seal}
            </p>
            <p className="mt-1 font-mono text-[8px] uppercase tracking-[0.16em] text-ash" data-id="element-123" data-mp="d9vrv8ytukht">
              Garantía
            </p>
          </div>
        </div>

        <div data-id="element-124" data-mp="m7eicsv8pr13">
          <p className="font-mono text-[9.5px] uppercase tracking-[0.2em] text-gold" data-id="element-125" data-mp="m7xozdffwszt">
            {content.eyebrow}
          </p>
          <h2 id="guarantee-title" className="mt-2.5 font-serif text-[22px] font-bold leading-tight text-parchment sm:text-[27px]" data-id="element-126" data-mp="vy0qk20mnf9r">
            {content.title}
          </h2>
          {content.paragraphs.map(paragraph => <p key={paragraph} className="mt-3 text-[14.5px] font-light leading-[1.72] text-smoke" data-id="element-127" data-mp="150a1uu3pzco7">
              {paragraph}
            </p>)}
        </div>
      </motion.div>
    </section>;
}